import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoaderInterceptor } from "@interceptors/request-loading-interceptor";
import { HttpRequestInterceptor } from "./http-request-interceptor";

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
];
